(() => {
  const mobileViewport = window.matchMedia('(max-width: 749px)');

  const setup = (info) => {
    if (!info || info.dataset.nlOrderInitialized === 'true') return;

    const directChild = (selector) => info.querySelector(':scope > ' + selector);
    const description = directChild('.product__description');
    const price = directChild('[id^="price-"]');
    const tax = directChild('.product__tax');
    const buy = Array.from(info.children).find((node) => node.querySelector(':scope > product-form.product-form'));
    const installmentForm = info.querySelector('form.installment');
    const installment = installmentForm?.parentElement?.parentElement === info ? installmentForm.parentElement : null;

    if (!price || !buy) return;

    const movers = [description, price, tax, installment].filter(Boolean);
    const originalNext = new Map(movers.map((node) => [node, node.nextElementSibling]));
    const shipping = tax?.children.length > 1 ? tax.children[1] : null;
    let arranged = false;

    const layout = () => {
      if (mobileViewport.matches) {
        if (arranged) return;
        const anchor = directChild('variant-selects') || buy;
        for (const node of [price, tax, installment]) {
          if (node?.parentElement === info) info.insertBefore(node, anchor);
        }
        if (shipping?.parentElement === tax) {
          shipping.classList.add('nl-mobile-shipping', 'caption', 'rte');
          buy.after(shipping);
        }
        if (description) (shipping?.parentElement === info ? shipping : buy).after(description);
        info.classList.add('nl-mobile-dom-order');
        arranged = true;
        return;
      }

      if (!arranged) return;
      info.classList.remove('nl-mobile-dom-order');
      if (shipping?.parentElement === info && tax) {
        shipping.classList.remove('nl-mobile-shipping', 'caption', 'rte');
        tax.append(shipping);
      }
      for (const node of [...movers].reverse()) {
        if (node.parentElement !== info) continue;
        let next = originalNext.get(node);
        if (next?.parentElement !== info && node === description) {
          next = directChild('variant-selects') || price;
        }
        if (next?.parentElement === info) info.insertBefore(node, next);
        else info.append(node);
      }
      arranged = false;
    };

    info.dataset.nlOrderInitialized = 'true';
    mobileViewport.addEventListener('change', layout);
    layout();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('product-info .product__info-container').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('product-info:loaded', (event) => {
    const info = event.target.querySelector('.product__info-container');
    if (info) setup(info);
  });
})();
